/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type GetInlineHelpQueryVariables = Exact<{
  id: string;
}>;

export type GetInlineHelpQuery = {
  getZalamoInlineHelp: {
    text: string | null;
    zalamoInlineHelpId: string | null;
  } | null;
};

export const GetInlineHelpDocument = gql`
  query getInlineHelp($id: ID!) {
    getZalamoInlineHelp(id: $id) {
      text
      zalamoInlineHelpId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetInlineHelpGQL extends Apollo.Query<
  GetInlineHelpQuery,
  GetInlineHelpQueryVariables
> {
  document = GetInlineHelpDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
